// extracted by mini-css-extract-plugin
module.exports = {"upload_button":"style-module_upload_button_2n1IE","upload":"style-module_upload_uvymf"};